import React, { useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import { ImageGrid as StyledImageGrid } from "./ImageGridStyles";

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.2, delayChildren: 0.1 } }
};

export default function ImageGrid({ data = {} }) {
  const { images = [] } = data;
  const imageGridRef = useRef(null);
  const imageGridControls = useAnimation();
  const imageGridInView = useInView(imageGridRef, { once: true });

  React.useEffect(() => {
    if (imageGridInView) imageGridControls.start("visible");
  }, [imageGridInView, imageGridControls]);

  return (
    <StyledImageGrid ref={imageGridRef}>
      <motion.div initial="hidden" animate={imageGridControls} variants={staggerContainer} style={{ display: 'contents' }}>
        {images.map((src, i) => (
          <motion.div
            key={i}
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.1, ease: "easeOut" } }
            }}
            whileHover={{ scale: 1.03, transition: { duration: 0.3 } }}
            style={{ borderRadius: '0px', overflow: 'hidden' }}
          >
            <img src={src} alt="Work" />
          </motion.div>
        ))}
      </motion.div>
    </StyledImageGrid>
  );
}
